import trackSpellChanges from '../helpers/trackSpellChanges'

function getSpellId(s) {
  return (
    s.character_spell_id || s.character_rune_spell_id || s.character_item_spell_id || s.id || null
  )
}

//---------------------
// process delete spell
//---------------------
export default function processDeleteSpell({
  spell,
  character,
  changed_spells = [],
  original_spells = [],
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteSpell spell = ', spell)
  console.log('spellsX = ', character.spells)
  //-----------------------------------------
  // build new array excluding deletion spell
  //-----------------------------------------
  const deleteId = getSpellId(spell)
  const newSpells = character.spells.filter((s) => getSpellId(s) !== deleteId)
  //------------------
  // assign new array
  //------------------
  character.spells = newSpells
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_spells = trackSpellChanges({
    spell,
    original_spells: original_spells,
    changed_spells: changed_spells,
    delete: true, // used to remove entry from changed_spells where is new local spell (not written to db yet)
  })
  console.log('updated_changed_spells after deletion:', updated_changed_spells)
  //---------
  // returns
  //---------
  return { character, updated_changed_spells }
}
